import * as React from 'react';
import Modal from '@mui/material/Modal';
import axios from 'axios';
import { useForm, SubmitHandler } from 'react-hook-form';
import {useEffect, useState} from 'react';
import { useNavigate } from "react-router-dom";
import { useCookies } from 'react-cookie';
import baseUrlApi from '../../lib/baseUrlApi';
import {ApiRequest} from "../../Consts/ApiRequest";
import { modalProps } from '../../Consts/constants';

type SensorAdminInputs = {
    sensorID: string;
    sensorName: string
    sensorKind: number;
};

interface SensorProps {
    sensorID: string;
    sensorName: string
    sensorKind: number;
    closeModal: Function;
    sensorRecno : string;
    setState: Function;
};

export default function GatewayAdminModalDelete(props: SensorProps) {
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [SensorAdminData, setSensorAdminData] = useState<SensorAdminInputs[]>([]);
    const [sensorID, setSensorID] = useState<string>(props.sensorID);
    const [sensorName, setSensorName] = useState<string>(props.sensorName);
    const [sensorKind, setSensorKind] = useState<number>(props.sensorKind);
    const [sensorRecno, setSensorRecno] = useState<string>(props.sensorRecno);
    const closeModal = props.closeModal;
    const { register: register, handleSubmit: handleSubmit, formState: { errors: errors } } = useForm<SensorAdminInputs>();
    // console.log(props.closeModal);
    const [cookies, setCookie, removeCookie] = useCookies(['authority', 'access_token', "siteId", "siteRecno"]);
    const navigate = useNavigate();

    const [error, setError] = useState<string[]>([]);

    useEffect(() => {
        setError([]);
    }, [open])

    function errorCallback(error:any){
        if (error.response && error.response.status === 401) {
            console.error("Error token error:", error);
            removeCookie('access_token', {path: '/'});
            removeCookie('authority', {path: '/'});
            removeCookie('siteId', {path: '/'});
            removeCookie('siteRecno', {path: '/'});
            navigate("logout");
        }
        console.error("Error fetching dataSite:", error);
    }

    const onSubmit = async () => {
        try {
            const token = cookies.access_token || "";
            let params = {
                "prcKind": 2,
                "sensorInfo": {
                    "sensorRecno": sensorRecno,
                    "sensorID": sensorID,
                    "sensorName": sensorName,
                    "sensorKind": Number(sensorKind)
                }
            };
            await ApiRequest.registSensor(params, token, (response: any) => {
                console.log(response);
                if (Array.isArray(response.data)) {
                    setSensorAdminData(response.data);
                }

                if (response.data.result === 0) {
                    handleClose();
                    closeModal();
                }else{
                    setError(response.data.messsages);
                }
                props.setState(" ")
            }, (error: any) => {
                errorCallback(error);
            });
        } catch (error) {
            console.error("Error fetching data:", error);
            alert("エラーが発生しました");
        }
    };

    return (
        <div>
            <button onClick={handleOpen} className="btn btn-red-line">
                <i className="icon-delete-r">
                </i>削除</button>

            <Modal {...modalProps} open={open}>
                <div className="modal-wrapper" style={{ display: "flex" }} id="modal-message">
                    <div className="modal">
                        <div className="modal-header">
                            <div className="modal-title">
                                削除確認
                            </div>
                            <a onClick={handleClose} className="modal-close"></a>
                        </div>

                        <div className="modal-body">
                            <div className="edit-box">
                                {
                                    error.length > 0 ?
                                        <ul className="error-box">
                                            {error.map((err, index) => <li key={index}>{err}</li>)}
                                        </ul>
                                        : null
                                }
                                本当に削除してもよろしいですか？
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="model-action-sub">
                            </div>
                            <div className="model-action-main">
                                <button onClick={handleClose} className="btn btn-blue-line">
                                    キャンセル
                                </button>
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <button className="btn btn-red-line">
                                        <i className="icon-delete-r"></i>確定
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
};
